module.exports = __webpack_public_path__ + "static/media/pw.4e697b04.svg";